<div class="selectbutton-container">
  <div class="selectbutton-group" [class.disabled]="disabled">
    <button
      placement="top"
      ngbTooltip="Moderno"
      [openDelay]="300"
      [container]="'body'"
      type="button"
      class="selectbutton-button"
      [class.selectbutton-selected]="!checked"
      (click)="toggle(false)"
      [disabled]="disabled"
    >
      <i class="bi bi-{{ option1 }}"></i>
    </button>
    <button
      placement="top"
      ngbTooltip="Clásico"
      [openDelay]="300"
      [container]="'body'"
      type="button"
      class="selectbutton-button"
      [class.selectbutton-selected]="checked"
      (click)="toggle(true)"
      [disabled]="disabled"
    >
      <i class="bi bi-{{ option2 }}"></i>
    </button>
  </div>
  @if(label) {
  <label class="selectbutton-label">{{ label }}</label>
  }
</div>
